import React from 'react';
import { formStyles } from '../utils/formStyles';
import { useTranslation } from 'react-i18next';

export function ExhibitionFormFields({ formData, handleChange, handleSubmit, isEdit = false, onCancel }) {
  const { t } = useTranslation();

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="relative">
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className={formStyles.input}
          required
        />
        <label htmlFor="name" className={`${formStyles.label} ${formData.name ? formStyles.labelActive : ''}`}>
          {t('exhibitionform.name')}
        </label>
      </div>
      
      <div className="relative">
        <input
          type="text"
          id="locations"
          name="locations"
          value={formData.locations}
          onChange={handleChange}
          className={formStyles.input}
          required
        />
        <label htmlFor="locations" className={`${formStyles.label} ${formData.locations ? formStyles.labelActive : ''}`}>
          {t('exhibitionform.locations')}
        </label>
      </div>
      
      <div className="relative">
        <input
          type="date"
          id="start_date"
          name="start_date"
          value={formData.start_date}
          onChange={handleChange}
          className={formStyles.dateInput}
          required
        />
        <label htmlFor="start_date" className={`${formStyles.label} ${formData.start_date ? formStyles.labelActive : ''}`}>
          {t('exhibitionform.start_date')}
        </label>
      </div>
      
      <div className="relative">
        <input
          type="date"
          id="end_date"
          name="end_date"
          value={formData.end_date}
          onChange={handleChange}
          className={formStyles.dateInput}
        />
        <label htmlFor="end_date" className={`${formStyles.label} ${formData.end_date ? formStyles.labelActive : ''}`}>
          {t('exhibitionform.end_date')}
        </label>
      </div>
      
      <div className="flex justify-end gap-4">
        <button type="submit" className={formStyles.button}>
          {isEdit ? t('exhibitionform.update') : t('exhibitionform.create')}
        </button>
        {isEdit && onCancel && (
          <button type="button" onClick={onCancel} className="px-4 py-2 bg-gray-300 dark:bg-zinc-700 rounded text-gray-800 dark:text-gray-200">
            {t('exhibitionform.cancel')}
          </button>
        )}
      </div>
    </form>
  );
}